const BLACKLISTS = [{
    value: 'bin',
    label: 'Bin',
}, {
    value: 'customer-id',
    label: 'Customer Id',
}, {
    value: 'country',
    label: 'Country',
}, {
    value: 'email',
    label: 'Email',
}, {
    value: 'email-domain',
    label: 'Email Domain',
}, {
    value: 'fingerprint',
    label: 'Fingerprint',
}, {
    value: 'ip-address',
    label: 'Ip Address',
}, {
    value: 'payment-card',
    label: 'Payment Card Fingerprint',
}, {
    value: 'bank-account',
    label: 'Bank Account Fingerprint',
}, {
    value: 'address',
    label: 'Address (street number/postal code)',
}];

export default BLACKLISTS;
